import "core-js/modules/es6.regexp.split";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations, mapActions } from 'vuex';
import registerStoreModule from '~/helpers/store-helper';
import { extractProductReference } from '~/helpers/extract-helper';
import product from '~/store/modules/product';
import { WIBILONG_JS_URL, WIBILONG_CSS_URL } from '~/const/3rd';
import MdmBreadcrumb from '~/components/atoms/Global/MdmBreadcrumb.vue';
import ProductGlide from '~/components/functional/UI/ProductGlide.vue';
import SquareImage from '~/components/atoms/Product/SquareImage.vue';
import ProductLoading from '~/components/organisms/Product/ProductLoading.vue';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/geoloc.svg';

const CommercialRibbon = () => import(
/* webpackChunkName: "commercial-ribbon" */
'~/components/atoms/Global/CommercialRibbon.vue');

const SmartBanner = () => import(
/* webpackChunkName: "smart-banner" */
'~/components/molecules/Product/SmartBanner.vue');

const StripesDecoration = () => import(
/* webpackChunkName: "product-sheet"  */
'~/components/atoms/Product/Decorations/StripesDecoration.vue');

const ThePriceSection = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/ThePriceSection.vue');

const TheVariantsSection = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/TheVariantsSection.vue');

const ZoomModal = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/molecules/Product/ZoomModal.vue');

const ThumbnailList = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/ThumbnailList.vue');

const TheEmailForm = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/molecules/Product/TheEmailForm.vue');

const TheCartSection = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/TheCartSection.vue');

const Reinsurance = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/Reinsurance.vue');

const ZoomableImage = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/molecules/Product/ZoomableImage.vue');

const Heart = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/atoms/Global/Heart.vue');

const ProductStock = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/atoms/Product/ProductStock.vue');

const TheSpecialEventSection = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/TheSpecialEventSection.vue');

const TagsDecorations = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/TagsDecorations.vue');

const CrossEarlyBirds = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/CrossEarlyBirds.vue');

const ShopTheLook = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/ShopTheLook.vue');

const ProductDetails = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/Details.vue');

const Description = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/Description.vue');

const ProductInformation = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/ProductInformation.vue');

const Olapic = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/Olapic.vue');

const Characteristics = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/Characteristics.vue');

const StoreAvailability = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/organisms/Product/StoreAvailability.vue');

const ProductSeo = () => import(
/* webpackChunkName: "product-seo-tracking" */
'~/components/functional/Seo/ProductSeo.vue');

const OpenGraph = () => import(
/* webpackChunkName: "product-seo-tracking" */
'~/components/functional/OpenGraph/ProductOpenGraph.vue');

const JsonLd = () => import(
/* webpackChunkName: "product-seo-tracking" */
'~/components/functional/JsonLD/ProductJsonld.vue');

const ProductSheetTcVars = () => import(
/* webpackChunkName: "product-seo-tracking" */
'~/components/functional/TcVars/ProductSheetTcVars.vue');

const PendingTag = () => import('~/components/functional/TcVars/PendingTag.vue');

export default {
  validate(_ref) {
    let {
      params: {
        alias
      }
    } = _ref;
    return alias && extractProductReference(alias);
  },

  components: {
    ProductLoading,
    CommercialRibbon,
    SquareImage,
    ZoomableImage,
    StripesDecoration,
    ThePriceSection,
    TheVariantsSection,
    ZoomModal,
    ProductGlide,
    Heart,
    ThumbnailList,
    ProductStock,
    TheSpecialEventSection,
    TagsDecorations,
    TheEmailForm,
    TheCartSection,
    Reinsurance,
    ProductDetails,
    Description,
    ProductInformation,
    Characteristics,
    StoreAvailability,
    Olapic,
    ShopTheLook,
    CrossEarlyBirds,
    MdmBreadcrumb,
    SmartBanner,
    ProductSeo,
    JsonLd,
    OpenGraph,
    ProductSheetTcVars,
    PendingTag
  },

  fetch(_ref2) {
    return _asyncToGenerator(function* () {
      let {
        params: {
          alias
        },
        query,
        store,
        error
      } = _ref2;
      registerStoreModule(store, 'product/', product);

      if (process.server) {
        try {
          yield store.dispatch('product/fetchProduct', {
            alias,
            query
          });
        } catch (err) {
          error({
            statusCode: 404,
            message: 'Not Found'
          });
        }
      }
    })();
  },

  asyncData() {
    return {
      serverFetch: process.server
    };
  },

  data() {
    return {
      olapic: null,
      asyncStylesheetMedia: 'none',
      stockAlert: false,
      showModal: false,
      imageIndex: 0,
      mediumLower: true,
      productGlideEnabled: true,
      trackingWibilongActive: false,
      trackingWibilongDisplay: null,
      isNewDescriptionBlock: false
    };
  },

  httpHeaders: () => ({
    'Cache-Control': 'max-age=0, s-maxage=600, public'
  }),
  computed: _objectSpread({}, mapGetters({
    baseURL: 'request/baseURL',
    locale: 'i18n/locale',
    productInspiration: 'product/productInspiration',
    productCross: 'product/productCross',
    productComplementary: 'product/productComplementary',
    product: 'product/product',
    currentImage: 'product/currentImage',
    variants: 'product/variants',
    salesPromotion: 'product/salesPromotion',
    categorySticker: 'product/categorySticker',
    estimatedDelivery: 'product/estimatedDelivery',
    delivery: 'product/delivery',
    tc_vars: 'product/tc_vars',
    tracking: 'product/tracking',
    gamme: 'product/gamme',
    olapicConfig: 'product/olapic'
  }), {
    isWibilongAuthorized() {
      return this.locale.market === 'FR';
    },

    showProductCross() {
      return this.productCross && this.productCross.products.length;
    },

    showProductComplementary() {
      return this.productComplementary && this.productComplementary.products.length;
    },

    trackingWibilongClick() {
      return {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Click_conseil_utilisateur',
          event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5, "/").concat(this.product.reference)
        }
      };
    },

    customizeProductUrl() {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/e/so-me-lampadaire?primary=").concat(this.product.reference, "&secondary=").concat(this.product.reference);
    },

    countryWithStores() {
      const excludedMarkets = ['UK', 'PT', 'AT', 'NL'];
      return excludedMarkets.filter(market => market === this.locale.market).length === 0;
    },

    sequraPredicate() {
      if (this.locale.market === 'ES' && !this.product.isPro && this.actualPrice >= 50) return true;
      return false;
    },

    actualPrice() {
      return this.product.price.sales.amount ? this.product.price.sales.amount : this.product.price.base.amount;
    },

    formattedBreadcrumb() {
      let result = [];

      if (this.product.additionalInformation.breadcrumbDisplay) {
        result = this.product.additionalInformation.breadcrumbDisplay.map(entry => ({
          text: entry.label,
          to: entry.hash ? "".concat(this.buildCategoryUrl(this.locale, 'slug', entry.hash)) : '',
          href: entry.url ? "".concat(entry.url) : "".concat(this.baseURL).concat(this.buildCategoryUrl(this.locale, 'slug', entry.hash))
        }));
      }

      return result;
    },

    hasAlertStockForm() {
      return this.product.stock.status === 'SOON' && this.product.additionalInformation.pricesType === 'T' || this.stockAlert;
    },

    hasVariants() {
      return this.variants.length;
    },

    isBuyable() {
      return this.product.additionalInformation.buyable;
    },

    currentPath() {
      return "".concat(this.baseURL).concat(this.buildProductUrl(this.locale, this.product.slug, this.product.reference));
    },

    hasSlider() {
      return this.isTablet() && this.product.images.length > 11 || this.isDesktop() && this.product.images.length > 5;
    },

    hasDetails() {
      const hasDetails = this.product.description.main || this.product.additionalInformation.collectionDescription || this.product.additionalInformation.additionalContent || this.product.additionalInformation.commonDetails;
      return Boolean(hasDetails);
    },

    hasDeliveryReinsurance() {
      return this.product.stock.status === 'IN_STOCK' || this.product.stock.status === 'WEEK' || this.product.stock.status === 'MONTH' || this.product.stock.status === 'LIMITED';
    },

    hasReinsurance() {
      return Boolean((this.product.additionalInformation.specialEvents.christmas_shipping || this.hasDeliveryReinsurance) && this.estimatedDelivery);
    },

    speedcurveConfig() {
      const luxConfig = {
        innerHTML: 'LUX = window.LUX || {}; LUX.label = "productsheet";'
      };
      return luxConfig;
    },

    openGraphMetaDescription() {
      return this.product.additionalInformation.metaDescription || '';
    }

  }),

  created() {
    registerStoreModule(this.$store, 'product/', product, true);

    if (process.client && !this.serverFetch) {
      const {
        params: {
          alias
        },
        query
      } = this.$route;
      const args = {
        alias,
        query,
        profileId: this.$cookies.get('eb-profile') ? this.$cookies.get('eb-profile').split(':')[0] : ''
      };
      this.resetProduct();

      try {
        this.fetchProduct(args).then(() => {
          this.wibilong();
        });
      } catch (error) {
        if (this.$sentry) {
          this.$sentry.captureException(error);
        }
      }
    }
  },

  mounted() {
    this.isNewDescriptionBlock = this.$cookies.get('new-description-block') === 1;

    if (this.serverFetch) {
      this.fetchCross();
    } else {
      this.createEbRecord();
    }

    this.bindScrollListener();
    this.stockAlert = this.$cookies.get('alertStock');
    this.mediumLower = !this.isDesktop();
  },

  destroyed() {
    this.unbindScrollListener();
  },

  methods: _objectSpread({}, mapMutations({
    resetProduct: 'product/RESET_PRODUCT'
  }), mapActions({
    fetchProduct: 'product/fetchProduct',
    fetchProductCarousels: 'product/fetchProductCarousels'
  }), {
    fetchCross() {
      const crossPredicate = this.productCross && this.productCross.products && this.productCross.products.length;
      const args = {
        alias: this.$route.params.alias,
        profileId: this.$cookies.get('eb-profile') ? this.$cookies.get('eb-profile').split(':')[0] : '',
        exclude: crossPredicate ? this.productCross.products.map(item => item.reference) : []
      };
      this.fetchProductCarousels(args).then(() => {
        this.createEbRecord();
        this.wibilong();
      });
    },

    createEbRecord() {
      const ebRecoIds = [];

      if (this.productCross) {
        const crossId = this.productCross.earlybirdsWidgets ? this.productCross.earlybirdsWidgets.id : null;
        ebRecoIds.push(crossId);
      }

      if (this.productComplementary) {
        const complementaryId = this.productComplementary.earlybirdsWidgets ? this.productComplementary.earlybirdsWidgets.id : null;
        ebRecoIds.push(complementaryId);
      }

      window.ebRecoIds = ebRecoIds;
    },

    emitGenericTrackingWibilong() {
      this.$root.$emit('generic-tracking', {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_questions reponses_wibilong',
          event_label: "".concat(window.tc_vars.page_cat1, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      });
    },

    bindScrollListener() {
      this.$root.$on('scroll-to-bottom', this.handleBottomBlocks);
      window.addEventListener('scroll', this.handleBottomBlocks, {
        passive: true
      });
    },

    unbindScrollListener() {
      this.$root.$off('scroll-to-bottom');
      window.removeEventListener('scroll', this.handleBottomBlocks);
    },

    handleBottomBlocks() {
      this.olapic = 'olapic';
      this.unbindScrollListener();
    },

    wibilong() {
      if (this.isWibilongAuthorized) {
        this.asyncScript(WIBILONG_JS_URL).then(() => {
          this.trackingWibilongActive = true;
          this.trackingWibilongDisplay = {
            data: {
              event_category: 'FicheProduit',
              event_action: 'Display_conseil_utilisateur',
              event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5, "/").concat(this.product.reference)
            }
          };
        }).catch(err => {
          console.error('WIBILONG_JS_URL FAILED', err);
        });
      }
    },

    handleWibilong() {
      this.asyncStylesheetMedia = 'all';
    },

    handleClickDescription(event) {
      try {
        const productInformation = document.getElementById('description-anchor'); // const { productInformation } = this.$refs.productInformation;

        window.scrollTo({
          top: productInformation.offsetTop - 100,
          behavior: 'smooth'
        });
      } catch (error) {
        console.log(error);
      }

      this.$root.$emit('generic-tracking', event, {
        fn: 'track-event',
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_description',
          event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      });
    },

    openModal() {
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
    }

  }),

  head() {
    return {
      link: [{
        rel: 'stylesheet',
        src: WIBILONG_CSS_URL,
        media: this.asyncStylesheetMedia,
        onload: this.handleWibilong
      }, {
        rel: 'prerender',
        url: "".concat(this.baseURL, "/").concat(this.locale.market, "/").concat(this.locale.language, "/panier.html")
      }],
      script: [this.speedcurveConfig]
    };
  }

};